import React, { useState } from "react";
import { Modal, DatePicker, Button, Typography, Space } from "antd";
import moment from "moment";

import dayjs from "dayjs";

const { Title, Text } = Typography;

const AuditDateModal = ({ auditorName, visible, onCancel, onConfirm, auditorId }) => {
  const [auditDate, setAuditDate] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);

  // const handleDateChange = (date) => {
  //   setAuditDate(date);
  //   console.log(date, auditDate, "audit assigned data")
  // };

  const handleDateChange = (date) => {
    setAuditDate(date);
    console.log("Selected date:", date?.format("DD/MM/YYYY"));
  };

  // const handleContinue = () => {
  //   if (auditDate) {
  //     console.log(auditDate, "sumbit assigndate")
  //     console.log(auditDate ? moment(auditDate).format("DD/MM/YYYY") : "sumbit assigndate")
  //     setIsConfirmed(true);
  //   }

  // };

  const handleContinue = () => {
    if (!auditDate) return;

    console.log(
      "Submit audit date:",
      auditDate.format("DD/MM/YYYY")
    );

    setIsConfirmed(true);
  };


  // const handleConfirmContinue = () => {
  //   if (onConfirm && auditDate) {
  //     // Merge current time with the selected audit date
  //     const mergedDate = moment(auditDate).set({
  //       hour: moment().hour(),
  //       minute: moment().minute(),
  //       second: moment().second(),
  //       millisecond: moment().millisecond(),
  //     });
  //     console.log(auditDate, mergedDate, "continue audit report")
  //     // Pass the merged date to the parent component
  //     onConfirm({ auditDate: mergedDate, auditorId });
  //   }
  //   setAuditDate(null);
  //   setIsConfirmed(false);
  // };

  const handleConfirmContinue = () => {
    if (onConfirm && auditDate) {
      const mergedDate = auditDate
        .hour(dayjs().hour())
        .minute(dayjs().minute())
        .second(dayjs().second())
        .millisecond(dayjs().millisecond());

      console.log(
        "Final audit date:",
        mergedDate.format("DD/MM/YYYY HH:mm:ss")
      );

      onConfirm({
        auditDate: mergedDate.toISOString(), // send clean value to backend
        auditorId,
      });
    }

    setAuditDate(null);
    setIsConfirmed(false);
  };


  return (
    <Modal
      visible={visible}
      footer={null}
      onCancel={onCancel}
      centered
      width={400}
    >
      {!isConfirmed ? (
        <>
          <Title level={4}>Assigned Auditor - {auditorName}</Title>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <div className="flex justify-around p-4">
              <p className="text-gray-600 font-medium">Choose the Audit Date:</p>
              <DatePicker
                value={auditDate}
                onChange={handleDateChange}
                format={"DD/MM/YYYY"}
                style={{ width: "40%" }}
                placeholder="Select Date"
              />
            </div>
            <div className="flex justify-between w-full">
              <Button
                onClick={onCancel}
                style={{ borderColor: "#E0E0E0", color: "#8c8c8c" }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={handleContinue}
                disabled={!auditDate}
              >
                Continue
              </Button>
            </div>
          </Space>
        </>
      ) : (
        <>
          <Title level={4}>Confirm your selection</Title>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <div className="flex flex-col items-center">
              <Text>
                <strong>Auditor name:</strong> {auditorName}
              </Text>
              <Text>
                <strong>Audit date:</strong>{" "}
                {auditDate ? auditDate?.format("DD/MM/YYYY") : "Not selected"}
              </Text>
            </div>
            <div className="flex justify-between w-full">
              <Button
                onClick={() => setIsConfirmed(false)}
                style={{ borderColor: "#E0E0E0", color: "#8c8c8c" }}
              >
                Back
              </Button>
              <Button
                type="primary"
                onClick={handleConfirmContinue}
                disabled={!auditDate}
              >
                Confirm
              </Button>
            </div>
          </Space>
        </>
      )}
    </Modal>
  );
};

export default AuditDateModal;
